import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'

import theme from './ApprovalItemDetails.scss'

const ApprovalItemDetails = (props) => {
  let riskIcon = (props.riskStatus === 'Risk') ?
    (<FontIcon class={`${theme.riskIcon} ${theme.icon}`} value='warning'/>) : null
  return (
    <Flex
      styleName='details'
      column auto
    >
      <Flex>
        <span class={theme.approvalItemCaption}>
          Project ID { props.projectId }
        </span>
        { riskIcon }
      </Flex>
      <span class={theme.approvalItemPartnerSite}>
        { props.partnerSite }
      </span>
      <div>
        <span class={theme.approvalItemProductSku}>
          { props.productSku }
        </span>
        <span class={theme.circle}/>
        <span class={theme.approvalItemGpuSku}>
          { props.gpuSku }
        </span>
      </div>
      <span class={theme.approvalProductClassType}>
        { props.productClassType }
      </span>
    </Flex>
  )
}

ApprovalItemDetails.propTypes = {
  productSku: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  partnerSite: PropTypes.string.isRequired,
  gpuSku: PropTypes.string.isRequired,
  riskStatus: PropTypes.string.isRequired,
}

export default CSSModules(ApprovalItemDetails, theme)
